// import { createSlice, PayloadAction } from '@reduxjs/toolkit';

// interface ServicesState {
//   selectedServiceTitle: string | null;
// }

// // Load initial state from localStorage if available
// const persistedState = localStorage.getItem('servicesState')
//   ? JSON.parse(localStorage.getItem('servicesState')!)
//   : null;

// const initialState: ServicesState = persistedState || {
//   selectedServiceTitle: null
// };

// const servicesSlice = createSlice({
//   name: 'services',
//   initialState,
//   reducers: {
//     setSelectedServiceTitle(state, action: PayloadAction<string | null>) {
//       state.selectedServiceTitle = action.payload;

//       // Save to localStorage whenever the state changes
//       localStorage.setItem('servicesState', JSON.stringify(state));
//     }
//   }
// });

// export const { setSelectedServiceTitle } = servicesSlice.actions;

// export default servicesSlice.reducer;



import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface ServicesState {
  selectedServiceTitle: string | null;
  selectedServiceId: string | null;
}

// Load initial state from localStorage if available
const persistedState = localStorage.getItem('servicesState')
  ? JSON.parse(localStorage.getItem('servicesState')!)
  : null;

const initialState: ServicesState = persistedState || {
  selectedServiceTitle: null,
  selectedServiceId: null
};

const servicesSlice = createSlice({
  name: 'services',
  initialState,
  reducers: {
    setSelectedServiceTitle(state, action: PayloadAction<string | null>) {
      state.selectedServiceTitle = action.payload;
      // Save to localStorage whenever the state changes
      localStorage.setItem('servicesState', JSON.stringify(state));
    },
    setSelectedService(state, action: PayloadAction<{ title: string | null; id: string | null }>) {
      state.selectedServiceTitle = action.payload.title;
      state.selectedServiceId = action.payload.id;
      // Save to localStorage whenever the state changes
      localStorage.setItem('servicesState', JSON.stringify(state));
    }
  }
});

export const { setSelectedServiceTitle, setSelectedService } = servicesSlice.actions;

export default servicesSlice.reducer;